// ImageUpload.tsx
import React, { useState, useRef } from "react";
import type { ChangeEvent } from "react";
import "./ImageUpload.css"; // We'll create this CSS file
import { auth } from "../auth/firebase";
import { useAuthState } from "react-firebase-hooks/auth";
//import { BASE_URL } from "../auth/types";
import ApiCall from "../auth/ApiCall";
import buttonBackground from "../assets/button_background_blue.webp";

// Type definitions
interface Avatar {
  avatar?: string;
  avatar_url?: string;
  //  [key: string]: any; // Allow additional properties
}

// interface UploadResponse {
//   avatar_url?: string;
//   //  [key: string]: any; // Allow additional properties
// }

interface ImageUploadProps {
  avatar: Avatar | string;
  // onImageUploaded?: (imageUrl: string) => void;
  currentImageUrl: string | null;
  setCurrentImageUrl: (url: string | null) => void;
  preview: string | null;
  setPreview: (preview?: string | null) => void;
}

const ImageUpload: React.FC<ImageUploadProps> = ({
  //  avatar,
  // onImageUploaded,
  //  currentImageUrl,
  setCurrentImageUrl,
  preview,
  //  setPreview,
}) => {
  const [uploading, setUploading] = useState<boolean>(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [user, loading, error] = useAuthState(auth);
  //  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  // const [uploading, setUploading] = useState(false);
  if (!user) {
    // console.error("User not authenticated");
    return;
  }

  const handleFileSelect = (event: ChangeEvent<HTMLInputElement>): void => {
    const file = event.target.files?.[0];
    if (!file) return;

    // Validate file
    if (!validateFile(file)) return;

    // Create preview
    const reader = new FileReader();
    reader.onload = (e: ProgressEvent<FileReader>) => {
      if (e.target?.result) {
        setCurrentImageUrl(e.target.result as string);
      }
    };
    reader.readAsDataURL(file);

    // Upload file
    uploadAvatar(file);
    // uploadImage(file);
  };

  const validateFile = (file: File): boolean => {
    // Check file size (5MB limit)
    if (file.size > 5 * 1024 * 1024) {
      alert("File size must be less than 5MB");
      return false;
    }

    // Check file type
    const validTypes: string[] = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/webp",
    ];
    if (!validTypes.includes(file.type)) {
      alert("Please select a valid image format (JPEG, PNG, WebP)");
      return false;
    }

    return true;
  };

  const uploadAvatar = async (selectedFile: File) => {
    if (!selectedFile) return;

    setUploading(true);

    const formData = new FormData();
    formData.append("avatar", selectedFile); // Direct file append

    try {
      await ApiCall.makeAuthenticatedRequest(
        "/accounts/api/avatar/webupdate/",
        {
          method: "POST",
          body: formData,
        },
        false,
      );
      // Handle success
    } catch {
      // console.error("Upload failed:", error);
    } finally {
      setUploading(false);
    }
  };

  // const uploadImage = async (file: File): Promise<void> => {
  //   setUploading(true);

  //   const formData = new FormData();
  //   formData.append("avatar", file);

  //   try {
  //     // Get the user's ID token
  //     const idToken = await user.getIdToken();

  //     // Make the request directly to avoid Content-Type issues with FormData
  //     const response = await fetch(BASE_URL + "/accounts/api/avatar/update/", {
  //       method: "POST",
  //       headers: {
  //         Authorization: `Bearer ${idToken}`,
  //         // Don't set Content-Type - let the browser set it with the boundary
  //       },
  //       body: formData,
  //     });

  //     if (!response.ok) {
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }

  //     const result = (await response.json()) as {
  //       data?: { avatar_url?: string };
  //       error?: string;
  //     };

  //     // Check for error in response
  //     if (result.error) {
  //       throw new Error(result.error);
  //     }

  //     // Update preview with the returned avatar URL from the server
  //     if (result.avatar_url) {
  //       const avatarUrl = result.data.avatar_url;
  //       // Build the full URL if it's a relative path
  //       const fullUrl = avatarUrl.startsWith("http")
  //         ? avatarUrl
  //         : BASE_URL + avatarUrl;

  //       setPreview(fullUrl);
  //       localStorage.setItem("avatar_url", fullUrl);
  //     } else {
  //       throw new Error("No avatar URL returned");
  //     }
  //   } catch (error) {
  //     console.error("Upload failed:", error);
  //     alert("Upload failed. Please try again.");
  //     setPreview(currentImageUrl); // Reset preview on error
  //   } finally {
  //     setUploading(false);
  //   }
  // };

  const handleClick = (): void => {
    fileInputRef.current?.click();
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;
  if (!user) return <div>Please sign in</div>;

  return (
    <div className="image-upload">
      <div className="image-preview" onClick={handleClick}>
        {preview ? (
          <img src={preview} alt="" className="preview-image" />
        ) : (
          <div />
        )}

        {uploading && (
          <div className="upload-overlay">
            <div className="spinner"></div>
            <span>Uploading...</span>
          </div>
        )}
      </div>

      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={handleFileSelect}
        style={{ display: "none" }}
      />

      {/* upload-button */}
      <button
        className="my-form-button-wide button-base button-3d font_family_base"
        style={{
          marginTop: "5px",
          marginBottom: "5px",
          backgroundImage: `url(${buttonBackground})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
          fontWeight: 700,
        }}
        // className={`my-form-button-wide center_me font_family_base button_text button_color  ${
        //   uploading ? "disabled" : ""
        // }`}
        onClick={handleClick}
        disabled={uploading}
      >
        {uploading ? "Uploading..." : "Change Avatar"}
      </button>
    </div>
  );
};

export default ImageUpload;
